module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer"
  }, [_c('div', {
    staticClass: "page-footer-inner"
  }, [_vm._v("\n     2019 © 康业物业管理（中山）有限公司\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll-to-top"
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eef996e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
// module id = 300
// module chunks = 2 3